/** Abrir chat WhatsApp (mismo patrón que useAsistenteVentas). */
export function normalizePhoneForWhatsApp(phone) {
  return String(phone || '').replace(/\D/g, '');
}

export function openWhatsAppChat(phone, text = '') {
  const normalized = normalizePhoneForWhatsApp(phone);
  if (!normalized) return false;
  const url = `https://wa.me/${normalized}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
